export default __webpack_public_path__ + "static/shop-interior-e1bbafbe4975947e81bace07314cc7fd.jpeg";